import { useCubeStore } from '@/stores/useCubeStore'
import { useEnvironment } from '@/composables/useEnvironment.ts'
import { useHttpClient } from '@/composables/useHttpClient'

type LogErrorInput = string | {
  message: string
  logLevel?: string
  data?: unknown
  timestamp?: Date
}

export function useLogError() {
  const { isProduction, env } = useEnvironment()
  const environmentKey = env['VITE_ENVIRONMENT'] as string
  const { backendApi } = useHttpClient()

  function logError(input: LogErrorInput) {
    console.error(input)

    const cube = useCubeStore()

    const data = typeof input === 'string' ? { message: input } : { ...input }
    if (!data.logLevel) { data.logLevel = 'error' }
    if (!data.timestamp) { data.timestamp = new Date() }

    if (!isProduction) {
      console.log(data)
      console.trace()
    }

    try {
      backendApi.post('/app/log', {
        appType: `appv2-${environmentKey}`,
        logLevel: data.logLevel,
        cubeName: cube.name,
        message: data.message,
        timestamp: data.timestamp,
        data: data.data ? JSON.stringify(data.data) : null,
      })
    } catch {
      console.error('Could not remotely log error: ' + data.message)
    }
  }

  return { logError }
}
